(() => {
  function initialize(root) {
    if (root.dataset.chReady) return;
    root.dataset.chReady = 'true';
    const section = root.closest('.shopify-section');
    if (!section) return;
    const panels = Array.from(root.querySelectorAll('[data-ch-variant]'));
    let variantId = root.dataset.initialVariant;
    let purchase = 'once';
    let planId = '';
    const defaults = new WeakMap();
    const forms = () => Array.from(section.querySelectorAll('form[action*="/cart/add"]'));
    function currentVariant() {
      const form = forms().find(f => !f.classList.contains('visually-hidden')) || forms()[0];
      return form?.querySelector('[name="id"]')?.value || variantId;
    }
    function sync() {
      const next = currentVariant();
      if (panels.some(p => p.dataset.chVariant === next)) variantId = next;
      const panel = panels.find(p => p.dataset.chVariant === variantId);
      if (!panel) return;
      panels.forEach(p => { p.hidden = p !== panel; });
      const select = panel.querySelector('[data-ch-plan]');
      if (!select) purchase = 'once';
      if (panel.dataset.required === 'true') purchase = 'subscription';
      if (select) {
        if (Array.from(select.options).some(o => o.value === planId)) select.value = planId;
        planId = select.value;
      }
      const subscribed = purchase === 'subscription' && !!select;
      panel.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = input.value === purchase;
        input.closest('[data-ch-option]').classList.toggle('is-selected', input.checked);
      });
      const details = panel.querySelector('[data-ch-subdetails]');
      if (details) details.hidden = !subscribed;
      const renewal = panel.querySelector('[data-ch-renewal]');
      if (renewal) renewal.hidden = !subscribed;
      const prices = panel.querySelector('[data-ch-prices]');
      const template = Array.from(panel.querySelectorAll('[data-ch-price]')).find(t => t.dataset.chPrice === planId);
      if (prices && template) prices.replaceChildren(template.content.cloneNode(true));
      panel.querySelectorAll('[data-ch-plan-detail]').forEach(el => { el.hidden = !subscribed || el.dataset.chPlanDetail !== planId; });
      forms().forEach(form => {
        let input = form.querySelector('input[name="selling_plan"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden'; input.name = 'selling_plan'; form.append(input);
        }
        input.value = subscribed ? planId : '';
        input.disabled = !subscribed;
        form.querySelectorAll('input[name="selling_plan"]').forEach(other => { if (other !== input) other.disabled = true; });
        form.querySelectorAll('[data-add-to-cart]').forEach(button => {
          const text = button.querySelector('[data-add-to-cart-text]');
          if (!text) return;
          if (!defaults.has(button)) defaults.set(button, {text:text.textContent.trim(), label:button.dataset.langAvailable || text.textContent.trim()});
          const original = defaults.get(button);
          const label = subscribed ? root.querySelector('[data-ch-button-label]').textContent.trim() : original.label;
          button.dataset.langAvailable = label;
          if (!button.disabled && button.getAttribute('aria-disabled') !== 'true' && !button.classList.contains('loading') && !button.classList.contains('is-loading')) {
            if (text.textContent.trim() !== label) text.textContent = label;
            button.setAttribute('aria-label', label);
          }
        });
      });
    }
    root.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) purchase = event.target.value;
      if (event.target.matches('[data-ch-plan]')) planId = event.target.value;
      sync();
    });
    section.addEventListener('change', () => { requestAnimationFrame(sync); });
    section.addEventListener('submit', sync, true);
    sync();
    let signature = '';
    const timer = setInterval(() => {
      if (!root.isConnected) { clearInterval(timer); return; }
      const next = currentVariant();
      const button = section.querySelector('[data-add-to-cart-text]');
      const nextSignature = next + '|' + (button?.textContent || '') + '|' + forms().length;
      if (nextSignature !== signature) { signature = nextSignature; sync(); }
    }, 250);
  }
  function scan(scope) { scope.querySelectorAll('[data-ch-subscription]').forEach(initialize); }
  scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
})();
